module.exports = __webpack_public_path__ + "img/ChTradicional-T600.adaf356e.gif";